// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"style_headerTitle__XRTba","line":"style_line__1Pepd","fontSize1":"style_fontSize1__2hQNl","bold":"style_bold__1kl0J","btn-edit":"style_btn-edit__3sCIJ"};